export default "__VITE_ASSET__KrgX_vpM__"